import { INgcConfig } from './config.interface';

/**
 * This file contains all the configuration values for the components
 */

export class ConfigDefaults implements INgcConfig {
  rootUrlName: string;

  constructor() {
    this.rootUrlName = 'home';
  }
}
